// extracted by mini-css-extract-plugin
export default {"wrapper":"EditProjectGeneralForm_wrapper__Cai+i","submitWrapper":"EditProjectGeneralForm_submitWrapper__0rpDv"};